import {detailServicesPath, ordersServicesPath, threeDConverterServicesPath} from "../../../../Constants";
import axios from "axios";

const fileRestOrdersUrl = ordersServicesPath + '/customers/files';
const fileRestDetailUrl = detailServicesPath + '/customers';

export default class FileService {
    static getFormData(selectedFile, name = "selectedFile") {
        const formData = new FormData();
        formData.append(name, selectedFile);
        return formData;
    }

    static getFormDataArray(files, name) {
        const formData = new FormData();
        files.forEach((file) => {
            formData.append(name, file);
        });
        return formData;
    }

    static async uploadRequestsCuttingFiles(files, requestCuttingId, orderId) {
        const query = requestCuttingId ? `&requestCuttingId=${requestCuttingId}` : ""
        return await axios.post(fileRestOrdersUrl + '/upload/order-requests-cutting-files/for-basis' + "?orderId="
            + orderId + query,
            FileService.getFormDataArray(files, "files"), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
    }

    static async uploadRequestsCuttingFilesWithSample(files, requestCuttingId, orderId) {
        const query = requestCuttingId ? `&requestCuttingId=${requestCuttingId}` : ""
        return await axios.post(fileRestOrdersUrl + '/upload/order-requests-cutting-files/for-basis-with-sample' + "?orderId="
            + orderId + query,
            FileService.getFormDataArray(files, "files"), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
    }

    static async uploadRequestsCuttingFilesPro100(files, requestsCuttingId, orderId) {
        return await axios.post(fileRestDetailUrl + "/orders/" + orderId + '/details/import/pro100' + "?requestsCuttingId="
            + requestsCuttingId,
            FileService.getFormData(files[0]), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });

    }

    static async uploadRequestsCuttingFilesPro100WithSample(files, requestsCuttingId, orderId) {
        return await axios.post(fileRestDetailUrl + "/orders/" + orderId + '/details/import/pro100' + "?requestsCuttingId="
            + requestsCuttingId + "&sample=true",
            FileService.getFormData(files[0]), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });

    }

    static async uploadRequestsCuttingFilesKDT(files, requestsCuttingId, orderId) {
        return await axios.post(fileRestDetailUrl + "/orders/" + orderId + '/details/save-all-by-import-kdt' + "?requestsCuttingId="
            + requestsCuttingId,
            FileService.getFormDataArray(files, "file"), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
    }

    static async uploadDetailSamples(files, group) {
        return await axios.post(fileRestDetailUrl + '/detail-samples/save-all-by-import-kdt' + "?group="
            + 1,
            FileService.getFormDataArray(files, "file"), {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
    }


    // static async uploadOrderSample(files, calculationRequestsCutting, requestCuttingId) {
    //     return await axios.post(fileRestOrdersUrl + '/upload/order-sample-file' + "?requestCuttingId="
    //         + requestCuttingId,
    //         FileService.getFormDataArray(files), {
    //             headers: {
    //                 "Content-Type": "multipart/form-data",
    //             }
    //         });
    // }

}